import { unlink, writeFile } from 'fs/promises';
import { SETUP } from '../constants';
import { exists } from '../helpers/exist';
import { getSetupFile } from '../helpers/getSetupFile';

export const writeConfig = () => {
  const path = getSetupFile();
  return writeFile(path, SETUP, { encoding: 'utf-8' });
};

export const removeConfig = async () => {
  const { check, path } = exists();

  if (check) return unlink(path);
};
